import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { c as g } from "../clsx-OuTLNxxd.js";
import { A as h, a as d } from "../Avatar-BG4Ek2lp.js";
import { B as f } from "../Button-CNdjOPcY.js";
import '../Profile.css';const r = "320px", _ = "600px", p = "1025px", z = "_profile_1pa9c_32", H = "_image_1pa9c_36", u = "_name_1pa9c_44", b = "_description_1pa9c_49", S = "_link_1pa9c_50", W = "_details_1pa9c_84", e = {
  mobile: r,
  "mobile-wide": "480px",
  tablet: _,
  "tablet-wide": "800px",
  desktop: p,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  profile: z,
  image: H,
  name: u,
  description: b,
  link: S,
  "layout-column": "_layout-column_1pa9c_77",
  "layout-row": "_layout-row_1pa9c_81",
  details: W,
  "size-s": "_size-s_1pa9c_91",
  "size-m": "_size-m_1pa9c_96",
  "size-l": "_size-l_1pa9c_107"
}, w = ({
  description: x,
  headingLevel: c = "h3",
  image: s,
  layout: a = "column",
  name: n,
  profileLink: i,
  size: m = "m",
  ...o
}) => {
  const y = c;
  return /* @__PURE__ */ l(
    "div",
    {
      "data-cxy-name": "profile",
      ...o,
      className: g(e.profile, e[`size-${m}`], e[`layout-${a}`], o.className),
      children: [
        /* @__PURE__ */ t(h, { className: e.image, children: /* @__PURE__ */ t(d, { alt: `Image of ${n}`, src: s }) }),
        /* @__PURE__ */ l("div", { className: e.details, children: [
          /* @__PURE__ */ t(y, { className: e.name, children: n }),
          x && /* @__PURE__ */ t("p", { className: e.description, dangerouslySetInnerHTML: { __html: x } }),
          i && /* @__PURE__ */ t(f, { asChild: !0, className: e.link, variant: "ghostBrand", children: /* @__PURE__ */ t("a", { href: i.href, children: i.text }) })
        ] })
      ]
    }
  );
};
export {
  w as Profile
};
